import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import BeforeContent from "../parts/before_content/before_content.js"
import AfterContent from "../parts/after_content/after_content.js"
import Background from "../parts/background/background.js"
import GridItem from "../parts/grid_item/grid_item.js"
import classNames from "classnames"

const Grid = ({ blok }) => {
  function grid_template_columns(per_row, gap){
    gap = (gap * (per_row - 1)) / per_row;
    const grid_width = "calc(" + (100/per_row).toString() + "% - " + gap.toString() + "px)"
    let grid_template_column_str = grid_width;
    for(let i = 1; i < per_row; i++){
      grid_template_column_str += " " + grid_width
    }

    return grid_template_column_str;
  }

  return (
    <section
      {...storyblokEditable(blok)}
      key={blok._uid}
      className={classNames("block_grid", "content_block", blok.class, ((blok.collapse_top_padding) ? 'collapse-top' : ''), ((blok.collapse_bottom_padding) ? 'collapse-bottom' : ''))}
    >
      <Background blok={blok.background_settings} />
      <div className="inner">
        <BeforeContent blok={blok.before_content} />

        {blok.grid_title && <h2 className="grid_title gs_reveal">{blok.grid_title}</h2>}

        {blok.grid_items && (
          <div
            className={classNames("grid_items", "cols_"+blok.per_row, {
              [`bg_${blok.grid_item_bg_color}`]: true,
              "grid_items--item-padding": blok.grid_item_padding
            })}
            style={{
              "--per-row" : grid_template_columns(blok.per_row, (blok.column_gap || 40)),
              "--per-row-m" : grid_template_columns(blok.per_row_mobile, (blok.column_gap_mobile || 20)),
              "--row-gap" : (blok.row_gap || 55) + "px",
              "--col-gap" : (blok.column_gap || 40) + "px",
              "--row-gap-m" : (blok.row_gap_mobile || 27.5) + "px",
              "--col-gap-m" : (blok.column_gap_mobile || 20) + "px",
              "--text-align" : blok.component_horozontal_align || 'center',
              '--content-vertical-align': blok.inner_content_vertical_align || "start",
              '--content-gap': (blok.inner_content_items_spacing || 0) + 'px',
              "--vertical-align" : blok.content_vertical_align || "stretch",
              "--horizontal-align" : blok.content_horizontal_align || "stretch"
            }}
          >
            {blok.grid_items.map(blok => (
              <GridItem key={blok._uid} blok={blok} />
            ))}
          </div>
        )}

        {!blok.grid_items && blok.empty_message && (
          <p className="empty-message">{blok.empty_message}</p>
        )}

        <AfterContent blok={blok.after_content} />
      </div>
    </section>
  )
}

export default Grid
